/** @format */

export const LinkedinMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M17.8333 2H6.16667C3.86583 2 2 3.86583 2 6.16667V17.8333C2 20.1342 3.86583 22 6.16667 22H17.8333C20.135 22 22 20.1342 22 17.8333V6.16667C22 3.86583 20.135 2 17.8333 2ZM8.66667 17.8333H6.16667V8.66667H8.66667V17.8333ZM7.41667 7.61C6.61167 7.61 5.95833 6.95167 5.95833 6.14C5.95833 5.32833 6.61167 4.67 7.41667 4.67C8.22167 4.67 8.875 5.32833 8.875 6.14C8.875 6.95167 8.2225 7.61 7.41667 7.61ZM18.6667 17.8333H16.1667V13.1633C16.1667 10.3567 12.8333 10.5692 12.8333 13.1633V17.8333H10.3333V8.66667H12.8333V10.1375C13.9967 7.9825 18.6667 7.82333 18.6667 12.2008V17.8333Z"
                fill={color}
            />
        </svg>
    );
};
